// HELPER FUNCTIONS
function gtm_add_cartAttribute(attr_name, attr_val, multiple_attr_array = []) {
  let body_attributes = `attributes[${attr_name}]=${attr_val}`;
  if(multiple_attr_array.length > 0){
    body_attributes = multiple_attr_array.join('&'); 
  }
  
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: body_attributes
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok.');
    }
    return response.json();
  })
  .then(data => {
    console.log('Cart updated successfully:', data);
    window.cart_attributes_updated = true;
  })
  .catch(error => {
    console.error('Failed to update cart:', error);
  });
}

// add experiment data to cart
setTimeout(() => {
  // 7.5s timeout is to allow tags to initialize, sub 8s pageviews are rarely valid anyhow
  let exp_cart_data = [];
  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    
    // Loop through the dataLayer 
    for (var i = 0; i < window.dataLayer.length; i++) {
      var dl_item = window.dataLayer[i];
      if (dl_item && typeof dl_item === 'object' && dl_item.event == "proteus_experiment_pageview") {
        var exp_id = dl_item.proteus_exp_id;
        var exp_var = dl_item.proteus_var_id;
        exp_cart_data.push("attributes[proteus-experimentation-" + exp_id.toLowerCase() + "]=[" + exp_id + "]" + exp_var);
        if(i == window.dataLayer.length - 1 && exp_cart_data.length > 0){
          // last loop
          console.log("add cart attributes exp_cart_data", exp_cart_data);
          gtm_add_cartAttribute(false, false, exp_cart_data);
        }     
      }
    }
    
  }

}, 7500)

function gtm_getVariation(number_of_variations) {
  try {
    return "v" + Math.floor(Math.random() * number_of_variations);
  } catch (e) {
    console.error('Error in gtm_getVariation:', e.message);
    return "v0";  // fallback value
  }
}

function gtm_getCookie(name) {
  try {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
    return null;
  } catch (e) {
    console.error('Error in gtm_getCookie:', e.message);
    return "v0";  // fallback value
  }
}

function gtm_setCookie(name, value, days) {
  try {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;domain=.{{*Base URL}}";
  } catch (e) {
    console.error('Error in gtm_setCookie:', e.message);
    // Here, you might want to do something else if setting the cookie fails.
    // Returning "v0" may not make sense in this context, but you could still handle the error in some manner.
  }
}
  
var getParam = function getParam(name, optSearch) {
  'use strict';

  optSearch = optSearch || location.search;
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(optSearch);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
  
function waitForElement(selector) {
  return new Promise(function (resolve, reject) {
    var element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var nodes = Array.from(mutation.addedNodes);
        for (var _i = 0, _nodes = nodes; _i < _nodes.length; _i++) {
          var node = _nodes[_i];
          if (node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        }
        ;
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  });
}

// shim layer with setTimeout fallback
var requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
    window.setTimeout(callback, 3000 / 60);
  };
}();
function waitUntil(test) {
  return new Promise(function (resolve) {
    (function poll() {
      if (!test()) return requestAnimFrame(poll, 50);
      return resolve();
    })();
  });
}
;
var observeSelector = function observeSelector(selector, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    timeout: null,
    once: false,
    onTimeout: null,
    document: window.document
  };
  var processed = new Map();
  if (options.timeout || options.onTimeout) {
    console.log('------------------------------------------------------------------------------------------------------------------------------');
    console.log('WARNING: observeSelector options timeout and onTimeout are not yet implemented.');
    console.log('------------------------------------------------------------------------------------------------------------------------------');
  }
  var obs,
    isDone = false;
  var done = function done() {
    if (!obs) console.warn('observeSelector failed to run done()');
    if (obs) obs.disconnect();
    processed = undefined;
    obs = undefined;
    return isDone = true;
  };
  var processElement = function processElement(el) {
    if (processed && !processed.has(el)) {
      processed.set(el, true);
      callback(el);
      if (options.once) {
        done();
        return true;
      }
    }
  };
  var lookForSelector = function lookForSelector() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    if (el.matches && el.matches(selector)) {
      if (processElement(el)) return true;
    }
    if (el.querySelectorAll) {
      var elements = el.querySelectorAll(selector);
      if (elements.length) {
        for (var i = 0; i < elements.length; i++) {
          var _el = elements[i];
          if (processElement(_el)) return true;
        }
      }
    }
  };
  lookForSelector();

  //We might finish before the mutation observer is necessary:
  if (!isDone) {
    obs = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (record) {
        if (record && record.addedNodes && record.addedNodes.length) {
          for (var i = 0; i < record.addedNodes.length; i++) {
            //Need to check from the parent element since sibling selectors can be thrown off if elements show up in non-sequential order
            var el = record.addedNodes[i].parentElement;
            // if (!el) console.warn('observeSelector element has no parent', record.addedNodes[i], record);
            //Note: This appears to also run when elements are removed from the DOM. If the element doesn't have a parent then we don't need to check it.
            if (el && lookForSelector(el)) return true;
          }
        }
      });
    });
    obs.observe(options.document || document, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }
  return function () {
    done();
  };
}; //_observeSelector

// alia event tracking -- v1.0
const aliaEvents = [
  "alia:popupView",
  "alia:signup",
  "alia:popupClose",
  "alia:campaignMatched",
  "alia:pollAnswered",
  "alia:rewardClaimed",
];

aliaEvents.forEach(function (evtName) {
  document.addEventListener(evtName, function (e) {
    console.log("ALIA event:", evtName, e.detail, `ALIA -- ${e.detail.popupID} ${e.detail.type}`);

    window.dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: "proteus_custom_event",
      proteus_event_name: `ALIA -- ${e.detail.popupID} ${e.detail.type}`,
      proteus_event_category: "CRO",
      page_location: window.location.href,
      alia_data: e.detail || {}
    });
  });
});

// postscript popup event tracking -- v1.0
window.addEventListener("postscriptPopup", function(e) {
  // console.log("POSTSCRIPT FULL", e);
  const detail = e?.detail;
  if (!detail || typeof detail !== "object" || !detail.type) return;
  console.log("POSTSCRIPT event", detail);

  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    'event': 'proteus_custom_event',
    'proteus_event_name': `PS ${e.detail.type} -- ${e.detail.popupId}`,
    'proteus_event_category': "CRO",
    'page_location': window.location.href
  });
});

// klaviyo event tracking -- v1.0
window.addEventListener("klaviyoForms", function(e) {

  console.log("KLAVIYO event", e)

  let form_id = e.detail.formId;
  let test_var = e.detail.formVersionId;

  dataLayer.push({
    'event': 'proteus_custom_event',
    'proteus_event_name': `KL ${form_id} ${e.detail.type} ${test_var}`,
    'proteus_event_category': "CRO",
    'page_location': window.location.href
  });

});

// attentive popup event tracking -- v1.1
window.addEventListener("message", function (e) {

  const a = e?.data?.__attentive;

  if (!a || !a.creativeId || !a.action) return;
  console.log("ATTENTIVE MESSAGE:", e.data);
  window.dataLayer = window.dataLayer || [];

  dataLayer.push({
    event: "proteus_custom_event",
    proteus_event_name: `ATTN ${a.creativeId} -- ${a.action}`,
    proteus_event_category: "CRO",
    page_location: location.href
  });
});

// proteus:cart-changed listener
(function () {

  var START_DELAY = 5000;
  var startTime = Date.now();
  var debounceTimer = null;

  var CART_REGEX = /\/cart(\/(add|update|change|clear)|\.js)/;

  function emitCartEvent(cart) {

    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(async function () {

      if (!cart?.items) {
        try {
          const res = await fetch("/cart.js");
          cart = await res.json();
        } catch(e) {}
      }

      document.dispatchEvent(
        new CustomEvent("proteus:cart-changed", { detail: cart })
      );

    }, 100);

  }

  function shouldEmit(url) {
    if (!url) return false;

    if (Date.now() - startTime < START_DELAY) return false;

    return CART_REGEX.test(url);
  }

  function getUrl(input) {
    if (!input) return null;

    if (typeof input === "string") return input;

    if (input.url) return input.url;

    return null;
  }

  // -------------------------
  // FETCH PATCH
  // -------------------------

  if (window.fetch && !window.__proteusFetchPatched) {

    window.__proteusFetchPatched = true;

    const originalFetch = window.fetch;

    window.fetch = function () {

      const args = arguments;
      const url = getUrl(args[0]);

      return originalFetch.apply(this, args).then(response => {

        try {

          if (shouldEmit(url)) {

            response.clone().json()
              .then(cart => emitCartEvent(cart))
              .catch(() => {});

          }

        } catch(e) {}

        return response;

      });

    };

  }

  // -------------------------
  // XHR PATCH
  // -------------------------

  if (window.XMLHttpRequest) {

    var originalOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {

      if (shouldEmit(url)) {

        this.addEventListener("load", function () {

          try {

            var data = JSON.parse(this.responseText);
            emitCartEvent(data);

          } catch(e) {}

        });

      }

      return originalOpen.apply(this, arguments);

    };

  }

})();